export * from './portfolio';
export * from './root';
export * from './services';
export * from './testimonials';
export const validateWebsite = () => ({ type: 'VALIDATE_WEBSITE' });



// WEBPACK FOOTER //
// ./src/store/actions/website/index.js